<!-- 快速采购 -->
<template>
    <div class="business-content-main quick-buy" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <!--    table    -->
        <div class="section-title">
            <div>商品明细</div>
            <div>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="(type == 3 || type == 5) && permission.searchAP">{{
                    permission.searchAP
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSubmitForm()" v-if="permission.submitOrder">创建采购单</el-button>
            </div>
        </div>

        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteListHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                @selection-change="selectionChange"
            >
                <ux-table-column type="checkbox" width="60" />

                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip :filters="[{ data: '' }]" :filter-method="filterAPCodeMethod" resizable>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot:filter="{ $panel, column }">
                        <el-input
                            type="type"
                            v-for="(option, index) in column.filters"
                            :key="index"
                            v-model="option.data"
                            @input="$panel.changeOption($event, option.data, option)"
                        />
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, rowIndex, 'code')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            :ref="'code' + scope.rowIndex"
                            :disabled="type == 4"
                            :loading="loading"
                            :allow-create="isCheckCode"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="searchCode"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="isCheckCode? optionItem.APCode: optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div style="width: 200px">{{ optionItem.APCode }}</div>
                                    <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                    <div>{{ optionItem.AutoSerise }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="GoodName" title="配件名称" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, rowIndex, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input size="small" v-model="scope.row.GoodName" v-if="scope.row.IsNew" :disabled="type == 4" placeholder="配件名称"></el-input>
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            :disabled="type == 4"
                            :loading="loading"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="searchName"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem.GoodName"
                            >
                                <div class="option-content">
                                    <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                    <div style="width: 200px">{{ optionItem.APCode }}</div>
                                    <div>{{ optionItem.AutoSerise }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>

                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, rowIndex, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input size="small" v-model="scope.row.AutoSerise" placeholder="车系" v-if="scope.row.IsNew" :disabled="type == 4"> </el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            :disabled="type == 4"
                            :loading="loading"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event)"
                            :remote-method="searchAutoSerie"
                            style="width: 100%"
                        >
                            <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isShowOrigin" width="100" resizable key="Origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                </ux-table-column>  
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>  
                <ux-table-column field="OnlyLeft" title="留余数" width="100" key="4" v-if="+type === 4">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                {{ isAddWaitIn ? '留余数=库存数-待出库数+待入库数' : '留余数=库存数-待出库数' }}<br />
                                注意：这里不统计退货商品数量
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.OnlyLeft }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Count" title="数量" width="100" key="5" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                :ref="'count' + scope.rowIndex"
                                :min="1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Unit" title="单位" width="80" key="6">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="UpLimit" v-if="type == 3" title="上限" width="80" key="12">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.UpLimit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="LowLimit" v-if="type == 3" title="下限" width="80" key="13">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.LowLimit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Balance" v-if="type == 3" title="留余" width="80" key="14">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Balance }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="SalePrice" title="销售价" width="100" key="7" v-if="+type === 4">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.SalePrice }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Price" title="采购价" width="100" key="8" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Price || row.Price === 0 }]">
                            {{ row.Price }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                size="small"
                                style="width: 100%"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.Price"
                                @input="priceChange"
                                placeholder="采购价"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column field="cgzj" title="采购总价" width="180" key="9">
                    <template v-slot="{ row }">
                        <div class="div-cgzj">
                            <img
                                v-if="(!row.IsAlreadyPurchase && type == 4) || type == 3 || type == 5"
                                class="image-sup"
                                src="@/assets/images/sup.png"
                                title="采购历史"
                                @click="showHistories(row.EntpTempGoodsId)"
                            />
                            <img v-if="type != 1" class="image-cus" src="@/assets/images/cus.png" title="销售历史" style="margin-left: 2px" @click="showSaleStat(row)" />
                            <img src="@/assets/images/analysis.png" style="width: 23px; height: 23px; margin-left: 4px" title="数据分析" @click="analysis(row)" />
                            <span class="number-cgzj">{{ row.Price * row.Count ? (row.Price * row.Count).toFixed(2) : 0 }}</span>
                        </div>
                    </template>
                </ux-table-column>

                <ux-table-column title="操作" width="120" key="11" v-if="+type === 3 || +type === 5">
                    <template v-slot="{ rowIndex }">
                        <div class="operate" v-if="type != 1">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete"></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>

        <!--    新增供应商   -->
        <el-dialog :close-on-click-modal="false" title="新增供应商" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :type="customerEditType" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP
                    :Source="1"
                    :EntpCusId="submitData.EntpCusId"
                    :SelectedData="selectedData"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!--   编辑订单信息    -->
        <el-dialog :close-on-click-modal="false" title="采购订单信息" :visible.sync="orderEditVisible" width="1200px">
            <div v-loading="!canRequest">
                <!--   form     -->
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px; margin-top: 30px" :rules="rules" id="form-order">
                    <div class="form-main">
                        <div class="form-left">
                            <el-form-item label="供应商" prop="EntpCusId">
                                <el-select
                                    v-model="submitData.EntpCusId"
                                    placeholder="请选择"
                                    filterable
                                    clearable
                                    remote
                                    style="width: 100%"
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchSupplierLoad"
                                    @change="customerChange($event)"
                                    @visible-change="customerVisibleChange($event)"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="结算方式" prop="PayType">
                                <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%" filterable clearable @visible-change="payVisibleChange($event)">
                                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="form-center">
                            <el-form-item label="业务员" prop="SId">
                                <el-select v-model="submitData.SId" filterable clearable remote placeholder="请选择" style="width: 100%" @visible-change="siVisibleChange($event)">
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="发货方式">
                                <el-select
                                    v-model="submitData.ShipType"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    filterable
                                    clearable
                                    @visible-change="sendWayVisibleChange($event)"
                                >
                                    <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="form-right">
                            <el-form-item label="运输费用" prop="ShipAmount">
                                <el-input type="number" step="0.01" min="0" v-model.trim="submitData.ShipAmount" @change="computeTotal"></el-input>
                            </el-form-item>
                            <el-form-item label="总额">
                                <el-input type="text" :disabled="true" :value="total"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-bottom">
                        <el-form-item label="入仓仓库" prop="WarehouseId">
                            <el-select
                                v-model="submitData.WarehouseId"
                                style="width: 66.66%"
                                placeholder="请选择"
                                filterable
                                clearable
                                @visible-change="warehouseVisibleChange($event)"
                                @change="warehouseChange"
                            >
                                <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"
                                    ><span style="float: left">{{ item.WarehouseName }}</span>
                                    <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="仓库地址" prop="WarehouseAddr">
                            <el-input v-if="canNotEditAddr" :title="submitData.WarehouseAddr" v-model="submitData.WarehouseAddr" :disabled="true" style="width: 66.66%"></el-input>
                            <el-input v-else v-model="submitData.WarehouseAddr" style="width: 66.66%"></el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input style="width: 66.66%" v-model.trim="submitData.Remark"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialog-footer" style="text-align: right; padding-right: 30px; margin-bottom: 30px">
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="(type == 3 || type == 4 || type == 5) && permission.addSupplier">{{
                        permission.addSupplier
                    }}</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="submitPurchaseForm(1, 1)" v-if="permission.submitOrder">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="APId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="APId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import customerEdit from '@/components/business/customerManage/customerEdit';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        searchAP,
        APMsg,
        APPurchaseHistory,
        breadcrumb,
        APHistory,
        goodsAnalysis
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isCheckCode: true,
            userMsg: userMsg,
            customerEditType: 1,
            dialogVisible: false,
            APMsgVisible: false,
            searchVisible: false,
            orderEditVisible: false,
            historyVisible: false,
            EntpTempGoodsIdEdit: '',
            EntpId: userMsg.EntpId,
            canRequest: true,
            dataReadonly: false,
            allNum: 1,
            allMoney: 0,
            loading: false,
            selectAll: false,
            total: 0,
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            canNotEditAddr: false,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            submitData: {
                SId: userMsg.EmployeeId,
                SubmissionState: false,
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                EntpCusOId: '', //转采购单时，需要将销售订单Id传值
                Sources: 0, //采购单来源 0 是直接采购；1 是库存需求转化的采购订单；2 销售单转化采购订单；3 询价转化的采购订单
                EntpCusId: '',
                PayType: null,
                ShipType: null,
                AddressId: null,
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                Bank: '',
                AccountName: '',
                Account: '',
                WarehouseId: '',
                WarehouseAddr: ''
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            bankList: [],
            accountList: [],
            accountNameList: [],
            addressList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            selectList: [],
            dataList: [],
            unitList: [],
            type: 0, //  3 库存采购； 4 销售转采购；5库存采购（库存商品列表过来的）
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [
                    {
                        required: true,
                        message: '填选择供应商',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: '请填写手机号',
                        trigger: 'blur'
                    }
                ],
                AddressId: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '填选择业务员',
                        trigger: 'change'
                    }
                ],
                WarehouseId: [
                    {
                        required: true,
                        message: '请选择仓库',
                        trigger: 'blur'
                    }
                ],
                WarehouseAddr: [{ required: true, message: '请填写仓库地址', trigger: 'blur' }]
            },
            permission: {},
            warehouseList: [],
            selectedData: [],
            infiniteListHeight: '', // 表格高度
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            isAddWaitIn: true,
            isShowBrand:false,//是否显示品牌
            isShowOrigin:false
        };
    },
    beforeRouteLeave(to, from, next) {
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.removeEventListener('click', this.clearActived, false);
        next();
    },
    mounted() {
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        this.permission = this.$util.getPermission('supplierBuyOrder');

        if (this.type == 3 || this.type == 5) {
            this.pageTitle = '库存采购';
        } else if (this.type == 4) {
            this.pageTitle = '转为采购单';
        }
        this.getConfigByCodes().then(() => {
            this.initDataList();
        });

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    methods: {
        initDataList() {
            if (this.type == 3 || this.type == 5) {
                let _dataList = this.$util.getLocalStorage('QuickBuyAP');
                for (let i = 0; i < _dataList.length; i++) {
                    this.dataList.push({
                        EntpTempGoodsId: _dataList[i].GoodsId,
                        APCode: _dataList[i].APCode,
                        GoodName: _dataList[i].GoodName,
                        Origin : _dataList[i].Origin,
                        AutoSerise: _dataList[i].AutoSerise,
                        Count: _dataList[i].RemainingInventoryQuantity < 0 ? Math.abs(_dataList[i].RemainingInventoryQuantity) : 0,
                        Price: _dataList[i].CostPrice, //这里是用商品的成本价作为采购价
                        Unit: _dataList[i].Unit,
                        Remark: '',
                        CodeRepeat: false,
                        OnlyLeft: _dataList[i].RemainingInventoryQuantity,
                        SalePrice: '',
                        State: 0,
                        Brand:_dataList[i].Brand,
                        UpLimit: this.type == 3 ? _dataList[i].UpLimit : _dataList[i].ExAttribute2,
                        LowLimit: this.type == 3 ? _dataList[i].LowLimit : _dataList[i].ExAttribute2,
                        Balance: _dataList[i].Inventory + (this.isAddWaitIn ? _dataList[i].NeedIn : 0) - _dataList[i].NeedOut - _dataList[i].BadGoodsCount
                    });
                }
                this.priceChange();
            } else if (this.type == 4) {
                this.getSaleOrder();
            }
        },
        // 筛选
        filterAPCodeMethod({ option, row }) {
            let val = option.data.replace(/(^\s*)|(\s*$)/g, '');
            if (val) {
                val = val.toUpperCase();
            }
            return row.APCode.toUpperCase().indexOf(val) != -1;
        },
        getSaleOrder() {
            this.dataList = [];
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderContainLeft',
                    data: {
                        EntpCusOId: this.id,
                        EntpId: this.EntpId,
                        isAddWaitIn: this.isAddWaitIn
                    }
                })
                .then(res => {
                    let _dataList = res.data.DetailList;
                    for (let i = 0; i < _dataList.length; i++) {
                        this.dataList.push({
                            EntpTempGoodsId: _dataList[i].EntpTempGoodsId,
                            APCode: _dataList[i].APCode,
                            GoodName: _dataList[i].GoodName,
                            AutoSerise: _dataList[i].AutoSerise,
                            Count: _dataList[i].Count,
                            Price: _dataList[i].CostPrice, //这里是用商品的成本价作为采购价
                            Unit: _dataList[i].Unit,
                            Remark: '',
                            CodeRepeat: false,
                            Inventory: _dataList[i].Inventory,
                            OnlyLeft: _dataList[i].OnlyLeft,
                            IsAlreadyPurchase: _dataList[i].IsAlreadyPurchase,
                            SalePrice: _dataList[i].Price, //销售价
                            State: _dataList[i].State,
                            Brand:_dataList[i].Brand,
                            Origin:_dataList[i].Origin,
                        });
                    }
                    this.priceChange();
                });
        },
        showSubmitForm() {
            //还要判断是否有选中的配件
            let that = this;
            let _total = 0;
            if (that.selectList.length == 0) {
                that.$util.warningMsg('请选择配件再进行采购');
                that.orderEditVisible = false;
            } else {
                that.selectList.forEach(item => {
                    _total += Number(item.Price) * Number(item.Count);
                });
                that.total = _total.toFixed(2);
                that.orderEditVisible = true;
            }

            let _dataList = that.selectList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    that.orderEditVisible = false;
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    that.orderEditVisible = false;
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    that.orderEditVisible = false;
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    that.$util.warningMsg('请填写正确的配件数量');
                    that.orderEditVisible = false;
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    that.orderEditVisible = false;
                    return;
                }
                if (!_dataList[i].Unit) {
                    that.$util.warningMsg('请填写单位');
                    that.orderEditVisible = false;
                    return;
                }
                if (!_dataList[i].Price || _dataList[i].Price < 0) {
                    that.$util.warningMsg('请填写正确的采购价');
                    that.orderEditVisible = false;
                    return;
                }
            }
            if (that.orderEditVisible && that.warehouseList.length == 0) {
                that.getWarehouse();
            }
        },
        computeTotal(val) {
            let that = this;
            let _total = that.total;

            _total = Number(val) + Number(_total);

            that.total = _total.toFixed(2);
        },
        getSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.SIdList = data;
            });
        },

        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;

            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let goods = that.dataList.find(e => item.APCode == e.APCode);
                if (!goods) {
                    let newGoods = {
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        Count: 1,
                        Price: item.Price ? item.Price : 0,
                        Unit: item.Unit,
                        Remark: item.Remark,
                        CodeRepeat: false,
                        State: 0,
                        Brand:item.Brand,
                        Origin:item.Origin,
                        UpLimit:item.UpperLimit,
                        LowLimit:item.LowerLimit,
                        Balance:item.Inventory
                    };
                    newGoodsList.push(newGoods);
                }
            }
            that.dataList = that.dataList.concat(newGoodsList);

            that.priceChange();
            that.searchVisible = false;
            that.$nextTick(() => {
                if (that.$refs['count' + (that.dataList.length - 1).toString()]) {
                    that.$refs['count' + (that.dataList.length - 1).toString()][0].focus();
                }
            });
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        checkCodeRepeat() {
            let repeatIndexs = [];
            let obj = {};
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                _dataList[i].CodeRepeat = false;
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    repeatIndexs = [...repeatIndexs, ...obj[key]];
                }
            }
            for (let j = 0; j < repeatIndexs.length; j++) {
                this.dataList[repeatIndexs[j]].CodeRepeat = true;
            }
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(2) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        // 提交采购单
        submitPurchaseForm(type, SubmissionState) {
            if (!this.canRequest) {
                return false;
            }
            this.$refs['formMsg'].validate(valid => {
                if (valid && this.canRequest) {
                    let _dataList = this.selectList;

                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!this.submitData.EntpCusId) {
                            this.$util.warningMsg('填选择供应商');
                            return;
                        }
                        if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                            this.$util.warningMsg('请填写正确的配件数量');
                            return;
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        if (!_dataList[i].Price || _dataList[i].Price < 0) {
                            this.$util.warningMsg('请填写正确的采购价');
                            return;
                        }
                    }
                    this.submitData.DetailList = _dataList;

                    this.canRequest = false;
                    if (SubmissionState) {
                        this.submitData.SubmissionState = SubmissionState;
                    }

                    let that = this;
                    let url = '/api/EntpPurchaseOrder/VerifySubmitEntpTransPurchaseOrder';
                    if (that.type == 3 || that.type == 5) url = '/api/EntpPurchaseOrder/IsExistPurchaseOrderBySId';
                    // 先验证是否已经有了该销售单转的同一个供应商的采购单
                    that.submitData.EntpCusOId = that.id;
                    that.submitData.Sources = 2;
                    that.$util
                        .axiosGet({
                            url: url,
                            data: {
                                SaleOrderId: that.id,
                                EntpCusId: that.submitData.EntpCusId
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            let result = res.data;
                            if (result && !result.IsExist) {
                                that.savePurchaseOrder();
                            } else if (result && result.IsExist) {
                                that.$confirm(`已有该供应商的采购单【${result.OrderCode}】，是否合并两张采购单?`, '提示', {
                                    confirmButtonText: '合并',
                                    cancelButtonText: '新建',
                                    type: 'warning',
                                    center: true,
                                    distinguishCancelAndClose: true,
                                    closeOnClickModal: false
                                })
                                    .then(() => {
                                        url = '/api/EntpPurchaseOrder/AddToEntpExistPurOrder';
                                        that.$util
                                            .axiosPost({
                                                url: url,
                                                data: that.submitData
                                            })
                                            .then(() => {
                                                that.$util.successMsg('合并采购单成功');
                                                if (that.type == 4) {
                                                    that.selectAll = false;
                                                    that.selectList = [];
                                                    that.getSaleOrder();
                                                    that.orderEditVisible = false;
                                                    that.canRequest = true;
                                                } else {
                                                    //清除参数缓存
                                                    that.$util.clearLocalStorage('QuickBuyAP');
                                                    setTimeout(() => {
                                                        that.canRequest = true;
                                                        window.history.go(-1);
                                                    }, 2000);
                                                }
                                            })
                                            .catch(() => {
                                                that.canRequest = true;
                                            });
                                    })
                                    .catch(action => {
                                        if (action !== 'cancel') return;
                                        that.savePurchaseOrder();
                                    });
                            }
                        })
                        .catch(() => {
                            that.canRequest = true;
                            that.$util.warningMsg('验证出现异常，请联系技术人员');
                        });
                }
            });
        },
        savePurchaseOrder() {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/SaveEntpPurOrder',
                    data: that.submitData
                })
                .then(() => {
                    that.$util.successMsg('创建采购单成功');
                    if (that.type == 4) {
                        that.selectAll = false;
                        that.selectList = [];
                        that.getSaleOrder();
                        that.orderEditVisible = false;
                        that.canRequest = true;
                    } else {
                        //that.type==3
                        //清除参数缓存
                        that.$util.clearLocalStorage('QuickBuyAP');
                        setTimeout(() => {
                            that.canRequest = true;
                            window.history.go(-1);
                        }, 2000);
                    }
                })
                .catch(() => {
                    that.canRequest = true;
                });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
        },
        // 搜索顾客
        searchCustomer(key) {
            this.loading = true;
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        // 获取地址
        getAddressList() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAddressList',
                    data: {
                        Page: 1,
                        Limit: 999,
                        EntpId: this.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    let _addressList = [];
                    for (let i = 0; i < data.length; i++) {
                        _addressList.push({
                            Text: `${data[i].Province}${data[i].City}${data[i].District}${data[i].Addr}`,
                            Value: data[i].Id
                        });
                    }
                    this.addressList = _addressList;
                });
        },
        // 搜索汽配编码
        searchCode(key) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        APCode: key,
                        Limit: this.Limit,
                        EntpId: this.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.codeList = res.data;
                });
        },
        // 搜索名称
        searchName(key) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        GoodName: key,
                        Limit: this.Limit,
                        EntpId: this.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.nameList = res.data;
                });
        },
        // 搜车系
        searchAutoSerie(key) {
            this.loading = true;
            this.$util.searchAutoSerie(key).then(data => {
                this.seriesList = data;
                this.loading = false;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        // 名称改变
        nameChange(value, index) {
            this.searchName();
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].APCode = _list[i].APCode;
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    }
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Price = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].Brand = _list[i].Brand;
                    this.dataList[index].Origin = _list[i].Origin;
                }
            }
            this.priceChange();
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.checkCodeRepeat();
            this.searchCode();
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                let checkItem = this.isCheckCode ? _list[i].APCode:_list[i].EntpTempGoodsId;
                if (checkItem == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Price = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].Brand = _list[i].Brand;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].IsNew = false;
                    isNew = false;
                }
            }
            if (isNew && value && this.isCheckCode) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Price = 0;
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].IsNew = true;
                        this.dataList[index].Brand ='';
                        this.dataList[index].Origin ='';
                        that.$nextTick(() => {
                            that.$refs['code' + index][0].blur();
                        });
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                }
                            });
                    }
                });
            }
            this.priceChange();
        },
        // 供应商改变
        customerChange(value) {
            this.submitData.Bank = '';
            this.submitData.AccountName = '';
            this.submitData.Account = '';
            if (value) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetCustOrderNewsData',
                        data: {
                            cid: this.submitData.EntpCusId,
                            type: '1'
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            this.submitData.ShipType = data.ShipType;
                            this.submitData.PayType = data.PayType;
                            if (data.PayType) {
                                this.payWayList = [
                                    {
                                        Value: data.PayType,
                                        Text: data.PayTypeName
                                    }
                                ];
                            }
                            if (data.ShipType) {
                                this.DeliveryMethodList = [
                                    {
                                        Value: data.ShipType,
                                        Text: data.ShipTypeName
                                    }
                                ];
                            }
                            if (data.Warehouse) {
                                if (!this.warehouseList.find(x => x.WarehouseId == data.Warehouse.WarehouseId))
                                    this.warehouseList.push({
                                        WarehouseId: data.Warehouse.WarehouseId,
                                        WarehouseName: data.Warehouse.WarehouseName,
                                        Address: data.Warehouse.Address,
                                        Type: data.Warehouse.WarehouseType
                                    });
                                this.submitData.WarehouseId = data.Warehouse.WarehouseId;
                                this.submitData.WarehouseAddr = data.Warehouse.Address;
                            } else {
                                this.submitData.WarehouseId = '';
                                this.submitData.WarehouseAddr = '';
                            }
                        }
                    });
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (this.customerList.length == 0) that.searchCustomer();
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('');
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        addressVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.addressList.length == 0) that.getAddressList();
            }
        },
        //结算方式下拉框显示时触发event
        payVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.payWayList.length <= 1) that.getPay();
            }
        },
        //当发货方式下拉框出现时触发
        sendWayVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.DeliveryMethodList.length <= 1) that.getSendWay();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
                        else this.canNotEditAddr = false;
                        return;
                    }
                }
            }
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.APId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top - 20;
        },
        // 选中项
        selectionChange(rows) {
            this.selectList = rows;
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'code' && !isNew) {
                setTimeout(() => {
                    this.$refs[`code${index}`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if(this.isCheckCode)
                rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else
                rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            var countColIndex=0;
            var sumColIndex=0;
            countColIndex=param.columns.findIndex(item=>{ return item.title == '数量'});
            sumColIndex=param.columns.findIndex(item=>{ return item.title == '采购价'});

            var arr=new Array(param.columns.length);
            if(countColIndex!=-1){
                arr[countColIndex]=this.allNum;
                 arr[countColIndex-1]="总数量";
            }
            if(sumColIndex!=-1){
                arr[sumColIndex]=this.allMoney.toFixed(3);
                arr[sumColIndex-1]="合计";
            }
            return [arr];               
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['lybsdr','kdxspp','xzqpbmdwyx','kdspcd'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'lybsdr'://获取留余的计算方式
                                    this.isAddWaitIn = !result;
                                    break; 
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;              
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;  
                                case 'kdspcd': //是否展示备注
                                    this.isShowOrigin = result;
                                    break;                                       
                            }
                        }
                    }
                    resolve();
                });
            });
        },        
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}

.form-main {
    display: flex;

    > div {
        width: 33.33%;
    }
}

.inventory-title {
    line-height: 1.2;
    flex-direction: column;

    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }

    > div:nth-child(2) {
        width: 100%;
        display: flex;

        > div {
            width: 33.33%;
        }
    }
}

.form-section {
    display: flex;
}

.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}

.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}

.option-content {
    display: flex;
    line-height: 30px;
}

.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}

.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}

.table-main {
    position: relative;
}

.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}

.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}

.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}

.table-item {
    height: 50px;
    position: relative;
}

.div-table-row {
    overflow: inherit;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>
<style lang="less">
.quick-buy {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body {
            .elx-body--row {
                .elx-body--column:first-child {
                    .elx-cell {
                        padding: 4px 10px 0;
                    }
                }
            }
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .div-cgzj {
                    padding: 2px 12px 0 8px;
                    .image-sup {
                        width: 27px;
                        height: 27px;
                    }
                    .image-cus {
                        width: 26px;
                        height: 26px;
                    }
                    .number-cgzj {
                        margin-left: 4px;
                    }
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        text-align: right;
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }
}
</style>
